document.addEventListener("DOMContentLoaded", () => {
  const tabla = document.querySelector(".tablaPrincipal");
  if (!tabla) return;

  // Delegación de eventos: Escuchamos clics en toda la tabla
  tabla.addEventListener("click", (event) => {
    
    // 1. Detectamos si el clic fue en una fila principal o dentro de ella
    const filaPrincipal = event.target.closest(".filaPrincipal");
    if (!filaPrincipal) return;

    // 2. Identificamos si el clic vino del botón específico o de la fila en general
    const esBoton = event.target.closest(".btnToggleDetalle");
    
    // Si fue el botón, evitamos que el evento suba (aunque en delegación no es estrictamente necesario, es buena práctica)
    if (esBoton) {
        event.stopPropagation();
    }

    // 3. Localizamos la fila de detalle (que siempre es la hermana siguiente)
    const filaDetalle = filaPrincipal.nextElementSibling;

    // Validamos que realmente sea una fila de detalle
    if (filaDetalle && filaDetalle.classList.contains("filaDetalle")) {
      const abierta = filaDetalle.classList.toggle("visible");
      filaPrincipal.classList.toggle("abierta", abierta);
    }
  });
});